const videoConstraints = (deviceId: string) => {
  return { deviceId: deviceId, height: 1024, width: 1280 }
}

export default videoConstraints
